module.exports = __webpack_public_path__ + "img/can_home_bg.53c151a0.jpg";